import {XCol, XPush, XText} from "../../components/xui";
import {cx, uiStyles} from "@cdx/common";
import {deckCreateStyles} from "./DeckCreatePlaceholder.css";
import {getModalUrl} from "../../components/ModalRegistry";
import {Link} from "react-router-dom";
import {DSIconButton, DSIconPlus} from "@cdx/ds";

const DecksCreatePlaceholderButton = ({message, to}) => {
  return (
    <XCol
      as={Link}
      to={to}
      pa={2}
      className={cx(deckCreateStyles.container, uiStyles.hideContainer)}
      relative
    >
      <XPush style={{flexGrow: 1.5}} />
      <XText
        color="gray500"
        className={cx(
          deckCreateStyles.message.base,
          !message && deckCreateStyles.message.onlyHoverVisible
        )}
        size={3}
        align="center"
      >
        {message}
      </XText>
      <XPush />
      <XCol align="end">
        <DSIconButton
          icon={<DSIconPlus />}
          size="lg"
          className={uiStyles.hideElement}
          tabIndex={-1}
        />
      </XCol>
    </XCol>
  );
};

const messagesByType = {
  deck: {
    defaultMessage: "Add deck",
    modal: "deckCreation",
  },
};

const DecksCreatePlaceholder = ({message, projectId, type, location, spaceId}) => {
  const typeData = messagesByType[type];
  const link = getModalUrl({modal: `${typeData.modal}.${projectId}`, state: {spaceId}, location});
  return <DecksCreatePlaceholderButton message={message || typeData.defaultMessage} to={link} />;
};

export default DecksCreatePlaceholder;
